
import Component from 'vue-class-component'
import Vue from 'vue'
import {Prop} from 'vue-property-decorator'

import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '../Atomic/CardTitle.vue'

import GuestService from '../../services/GuestService'

import {INotificationService} from '../../services/NotificationService'
import ErrorHandler from '@/services/ErrorHandlerService'

import moment from 'moment'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'
import GuestUser, {GuestForTable} from '@/models/user'
import {State} from 'vuex-class'
import {User as Storeuser} from '../../store/index'
import {JobTitle} from "@/models/jobTitles";

@Component({
  components: {
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
    ProgressLinear,
  },
})
export default class GuestForm extends Vue {
  @Prop(Function) public readonly onClose!: () => void
  @State private user!: Storeuser
  private guest: GuestForTable = new GuestForTable(
    0,
    0,
    '',
    '',
    '',
    '',
    '',
    0,
    '',
    '',
    false,
    '',
    0
  )
  private dialog: boolean = false
  private isPending: boolean = false
  private jobTitles: JobTitle[] = []
  private forCreate: boolean = true

  private $notificationService!: INotificationService
  private errorHandler = new ErrorHandler()
  private foundGuest:GuestForTable | undefined;
  private guestDialog: boolean = false
  private async created() {
    this.jobTitles = await GuestService.fetchJobTitles()
  }

  private closeFoundGuestDialog(){
    this.foundGuest = undefined
    this.guestDialog = false
  }

  private useFoundGuest(){
    this.guest.first_name = this.foundGuest!.first_name
    this.guest.last_name = this.foundGuest!.last_name
    this.guest.email = this.foundGuest!.email
    this.foundGuest = undefined
    this.guestDialog = false
  }
  public show(account: GuestForTable | null, forCreate: boolean) {
    this.forCreate = forCreate
    if (account !== null) {
      this.guest = account
    }
    if (this.user.schools.length === 1) {
      this.guest.school_id = this.user.schools[0].etablissement_id
    }

    this.dialog = true

  }

  private async validate() {
    const validated = await this.$validator.validateAll()
    if (validated) {
      this.isPending = true
      try {
        if (this.guest.id === 0) {
          await GuestService.create(this.guest)
          this.$notificationService.success(this.$t('GUESTS.CreationSuccess').toString())
          this.closeDialog()
        } else {
          await GuestService.update(this.guest, this.guest.id)
          this.$notificationService.success(this.$t('GUESTS.UpdateSuccess').toString())
          this.closeDialog()
        }
      } catch (error: any) {
        console.log(error.response.data)
        this.errorHandler.handle(this, error.response.data.code, true)
      } finally {
        this.isPending = false
      }
    }
  }

  private async checkExistingMail(){
      console.log("Checking")
    if(this.forCreate){
      try {
        this.foundGuest = await GuestService.CheckForEmail(this.guest.email)
        this.guestDialog = true
      }
      catch (error: any){

      }
    }
  }

  private closeDialog() {
    this.$validator.reset()
    this.guest = new GuestForTable(
      0,
      0,
      '',
      '',
      '',
      '',
      '',
      0,
      '',
      '',
      false,
      '',
      0
    )
    this.onClose()
    this.dialog = false
  }
}
